import * as t from '../i18n/pt-BR'

/** Tela provisória da rota "/" até o shell autenticado chegar. */
export function LoadingScreen() {
  return (
    <main className="grid min-h-dvh place-items-center bg-canvas">
      <p role="status" aria-live="polite" className="text-body text-ink-2">
        {t.common.loading}
      </p>
    </main>
  )
}
